import React, { Component } from "react";
import { GlobalContext}  from "../../../../utils/globalprovider.js"
import "./assetsmanager.css"



class AssetSectionTitle extends React.Component
{

  static contextType = GlobalContext;
  constructor(props) 
  {
    super(props);   
    }
  
  render()
  {



    return(
        <div className="AssetSectionTitle" >
          {this.context.language==="fr"?this.props.title.fr:this.props.title.en}
          
        </div>
    )



  }


}

export default AssetSectionTitle;